import { css } from "@emotion/react";

import { Typography } from "components/shared/library/Typography";

import { formatDocumentFilename } from "utils/document";
import { down } from "utils/mediaQueryStrings";

import { uiGray } from "constants/colors";

const style = {
  file: css({
    border: `1px solid ${uiGray[10]}`,
    borderRadius: 8,
    padding: 8,
    display: "flex",
    gap: 8,
    alignItems: "center",
  }),
  filename: css({
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    [down("mobile")]: { flex: 1 },
  }),
  fileSize: css({ flexShrink: 0 }),
};

export const FileItem = ({
  name,
  size,
  LeftComponent,
}: {
  name: string;
  size?: string;
  LeftComponent: () => JSX.Element;
}) => {
  return (
    <div key={name} css={style.file}>
      <LeftComponent />
      <Typography color={uiGray[70]} weight="medium" customCss={style.filename}>
        {formatDocumentFilename(name) || name}
      </Typography>
      {size && (
        <Typography color={uiGray[40]} customCss={style.fileSize}>
          {size}
        </Typography>
      )}
    </div>
  );
};
